import Vue from "vue"
import Router from "vue-router"

import IndexVue from '../pages/index.vue'
import LoginVue from '../pages/login.vue'
import ForgetVue from '../pages/forget.vue'
import RegisterVue  from "../pages/register.vue"
import DetailVue from '../pages/detail.vue'
import CategoryVue from '../pages/category.vue'
import ConfirmOrderVue from "../pages/confirmOrder.vue"
import CarVue from '../pages/car.vue'
import InfoVue from '../pages/info.vue'
import AppraisalVue from "../pages/appraisal.vue"
import MyVue from '../pages/my.vue'
import CommentVue from '../pages/comment.vue'
import PayVue from '../pages/pay.vue'
import DownloadVue from '../pages/download.vue'
import GuideVue from '../pages/guide.vue'

Vue.use(Router)

export default new Router({
	routes:[
		{
			path:"/",
			name:'IndexVue',
			component: IndexVue
		},
		{
			path:"/index",
			name:'IndexVue',
			component: IndexVue
		},
		{
			path:'/login',
			name:'LoginVue',
			component:LoginVue
		},
		{
			path:'/forget',
			name: 'ForgetVue',
			component:ForgetVue
		},{
			path:"/register",
			name:"RegisterVue",
			component:RegisterVue
		},{
			path:"/detail",
			name:'DetailVue',
			component:DetailVue,
		},{
			path:"/category",
			name:"CategoryVue",
			component:CategoryVue
		},{
			path:'/confirmOrder',
			name:'ConfirmOrderVue',
			component:ConfirmOrderVue
		},{
			path:'/car',
			name:'CarVue',
			component: CarVue
		},{
			path:'/info',
			name:"InfoVue",
			component: InfoVue
		},{
			path:'/appraisal',
			name:"AppraisalVue",
			component:AppraisalVue
		},{
			path:'/my',
			name:'MyVue',
			component:MyVue
		},{
			path:'/comment',
			name:"/CommentVue",
			component:CommentVue
		}, {
			path: '/pay',
			name: '/PayVue',
			component: PayVue
		},{
			path:'/download',
			name:'/DownloadVue',
			component:DownloadVue
		},{
			path:'/guide',
			name:'/GuideVue',
			component: GuideVue
		}
	],
	scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 浏览器前进/后退时恢复之前的位置
      return savedPosition;
    } else if (to.hash) {
      // 处理hash锚点定位
      return { selector: to.hash };
    } else {
      // 新页面滚动到顶部
      return { x: 0, y: 0 };
    }
  }
})